/**
 * @file
 * Video Thumbnail Formatter — click thumbnail to reveal and play video.
 */
(function (Drupal, once) {
  Drupal.behaviors.videoThumbnailFormatter = {
    attach(context) {
      once(
        "video-thumbnail-formatter",
        ".video-thumbnail-formatter",
        context
      ).forEach((wrapper) => {
        const thumbnail = wrapper.querySelector(
          ".video-thumbnail-formatter__thumbnail"
        );
        const playBtn = wrapper.querySelector(
          ".video-thumbnail-formatter__play-btn"
        );
        const videoContainer = wrapper.querySelector(
          ".video-thumbnail-formatter__video"
        );

        if (!thumbnail || !videoContainer) return;

        function playYoutubeVideo(iframe) {
          if (undefined === iframe.contentWindow) {
            return;
          }

          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "playVideo",
            }),
            iframe.src
          );
        }

        function playVimeoVideo(iframe) {
          // eslint-disable-next-line no-undef
          const player = new Vimeo.Player(iframe);
          player.play();
        }

        function activateVideo() {
          // Hide thumbnail.
          thumbnail.hidden = true;

          // Show video container.
          videoContainer.removeAttribute("hidden");

          const formatContainer = videoContainer.querySelector(
            ".video-embed-field-responsive-video"
          );

          const format =
            Array.from(formatContainer.classList)
              .find((item) => item.startsWith("video-embed-field-provider-"))
              ?.replace("video-embed-field-provider-", "") ?? null;

          const iframe = formatContainer.querySelector("iframe");
          if (iframe && format) {
            if (format === "youtube") {
              playYoutubeVideo(iframe);
              return;
            }

            if (format === "vimeo") {
              playVimeoVideo(iframe);
            }
          }
        }

        if (playBtn) {
          playBtn.addEventListener("click", activateVideo);
        }

        // Also allow clicking the thumbnail image itself.
        thumbnail.addEventListener("click", activateVideo);
      });
    },
  };
})(Drupal, once);
